export enum EnrollmentTabAction {
  WAIVE_COVERAGE = 'WAIVE_COVERAGE',
  RESET_ELECTION = 'RESET_ELECTION',
  UNDO_ENROLLMENT_CONFIRMATION = 'UNDO_ENROLLMENT_CONFIRMATION',
  UNDO_APPLICATION = 'UNDO_APPLICATION',
  CHANGE_ELECTION_WINDOW = 'CHANGE_ELECTION_WINDOW',
  MANUAL_SUBMISSION = 'MANUAL_SUBMISSION',
}
